import DataExtractionFieldBase from './DataExtractionFieldBase';

export const __typename = 'DataExtractionFieldSingleSelectDto';
export default class DataExtractionFieldSingleSelect extends DataExtractionFieldBase {
  constructor(data = {}) {
    super({
      ...data,
      __typename,
    });

    this.multipleChoiceOptions = data.multipleChoiceOptions ?? [];
    this.otherOption = data.otherOption ?? false;
  }
}
